// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
const DEVELOPMENT_API_URLS = {
  APP_DISTRIBUTION:
    "https://app-distribution-vewd-cs-integration.integration.tivoservice.net",
  APP_INVENTORY:
    "https://app-inventory-vewd-cs-integration.integration.tivoservice.net",
  APP_MANIFESTS:
    "https://app-manifests-vewd-cs-integration.integration.tivoservice.net",
  AUTH_BAKER:
    "https://auth-baker-vewd-cs-integration.integration.tivoservice.net",
  CONTENT_MGMT:
    "https://content-mgmt-vewd-cs-integration.integration.tivoservice.net/admin",
  CONTENT_SUITE_API:
    "https://content-suite-api-vewd-cs-integration.integration.tivoservice.net",
  DEVICE_MGMT:
    "https://device-mgmt-vewd-cs-integration.integration.tivoservice.net",
  ELASTIC_SEARCH:
    "https://search-engine-vewd-cs-integration.integration.tivoservice.net",
  JIRA: "https://bugs.corp.vewd.com",
  MESSAGE_CENTER:
    "https://message-center-vewd-cs-integration.integration.tivoservice.net",
  MODERATION:
    "https://moderation-vewd-cs-integration.integration.tivoservice.net",
  PROMOTIONS:
    "https://promotions-vewd-cs-integration.integration.tivoservice.net",
  SNAP_API:
    "https://snapapi-vewd-cs-integration.integration.tivoservice.net/api/v1",
  TIVO_APPS:
    "https://tivo-app-inventory-vewd-cs-integration.integration.tivoservice.net",
  USER_CATALOGUE:
    "https://user-catalogue-vewd-cs-integration.integration.tivoservice.net",
};

const PRODUCTION_API_URLS = {
  APP_DISTRIBUTION: "https://app-distribution.tvint.qa",
  APP_INVENTORY: "https://app-inventory.tvint.qa",
  APP_MANIFESTS: "https://app-manifests.tvint.qa",
  AUTH_BAKER: "https://auth-baker.tvint.qa",
  CONTENT_MGMT: "https://content-mgmt.tvint.qa/admin",
  CONTENT_SUITE_API: "https://content-suite-api.tvint.qa",
  DEVICE_MGMT: "https://device-mgmt.tvint.qa",
  ELASTIC_SEARCH: "https://search-engine.tvint.qa",
  JIRA: "https://bugs.corp.vewd.com",
  MESSAGE_CENTER: "https://message-center.tvint.qa",
  MODERATION: "https://moderation.tvint.qa",
  PROMOTIONS: "https://promotions.tvint.qa",
  SNAP_API: "https://snapapi.tvint.qa/api/v1",
  TIVO_APPS: "https://tivo-app-inventory.tvint.qa",
  USER_CATALOGUE: "https://user-catalogue.tvint.qa",
};

export const API_URLS =
  process.env.NODE_ENV === "production"
    ? PRODUCTION_API_URLS
    : DEVELOPMENT_API_URLS;
